/**
 * Tencent is pleased to support the open source community by making SPA UI available.
 * Copyright (C) 2020, a Tencent company. All rights reserved
 */
export default {
  componentName: 'odc',
  componentVersion: '0.0.0',
  name: 'odc',
  version: '0.0.0',
};
